import { SkeletonCard } from './SkeletonCard';

export const SkeletonLayout = () => (
  <div className="w-full">
    <SkeletonCard />
    <div className="h-4" />
    <SkeletonCard />
  </div>
);
